// platnosci.js - vanilla JS replacement for jQuery script

let _krajHandler = null;
let _platnosciHandler = null;
let _wysylkaHandler = null;
let _czyFirmaHandler = null;

function postForm(url, dataObj) {
  const body = new URLSearchParams(dataObj).toString();
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body,
    credentials: 'same-origin',
  }).then(res => res.text());
}

export function wyborKraju() {
  const select = document.querySelector('select[name="id_kraj"]');
  if (!select) return false;

  let id_kraj = select.value;
  if (id_kraj === undefined || id_kraj === null) id_kraj = 0;

  const ladowanie = '<div class="progress-bar"></div>';

  // zdarzenie delegowane - usuwamy stare, dodajemy nowe
  if (_krajHandler) document.body.removeEventListener('change', _krajHandler);
  _krajHandler = function (e) {
    if (e.target && e.target.matches('select[name="id_kraj"]')) {
      wyborKraju();
      e.preventDefault();
    }
  };
  document.body.addEventListener('change', _krajHandler);

  // wgrywanie listy płatności - kasowanie i wrzucenie loadera
  const platDivs = Array.from(
    document.querySelectorAll('.platnosc-pojemnik div')
  );
  if (platDivs.length > 0) {
    platDivs.forEach(d => (d.innerHTML = ladowanie));
    postForm('/koszyk/platnosci_lista', { id_kraj })
      .then(data => {
        platDivs.forEach(d => (d.innerHTML = data));
      })
      .catch(() => {
        // opcjonalnie: obsługa błędu
      });
  }

  // wywołanie kolejnego kroku
  wyborPlatnosci();
  return false;
}

export function wyborPlatnosci() {
  const selectPlat = document.querySelector('select[name="id_platnosci"]');
  if (!selectPlat) return false;

  const ladowanie = '<div class="progress-bar"></div>';

  // usuwamy i ponownie przypinamy handler zmiany selecta
  if (_platnosciHandler)
    document.body.removeEventListener('change', _platnosciHandler);
  _platnosciHandler = function (e) {
    if (e.target && e.target.matches('select[name="id_platnosci"]')) {
      wyborPlatnosci();
      e.preventDefault();
    }
  };
  document.body.addEventListener('change', _platnosciHandler);

  // odczyt id_kraj z inputa (jeśli jest) lub 0
  const inputKraj = document.querySelector('input[name="id_kraj"]');
  let id_kraj = inputKraj ? inputKraj.value : 0;
  if (id_kraj === undefined || id_kraj === null) id_kraj = 0;

  let id_platnosci = selectPlat ? selectPlat.value : 0;
  if (id_platnosci === undefined || id_platnosci === null) id_platnosci = 0;

  // wgrywanie opisu płatności
  const opisElems = Array.from(
    document.querySelectorAll('.platnosc-pojemnik div .opis-platnosci')
  );
  if (opisElems.length > 0) {
    opisElems.forEach(el => (el.innerHTML = ladowanie));
    postForm('/koszyk/platnosc_info', { id_kraj, id_platnosci })
      .then(data => {
        opisElems.forEach(el => (el.innerHTML = data));
      })
      .catch(() => {});
  }

  // wgrywanie listy wysyłki
  const wysylkaContainers = Array.from(
    document.querySelectorAll('.wysylka-pojemnik')
  );
  if (wysylkaContainers.length > 0) {
    wysylkaContainers.forEach(el => (el.innerHTML = ladowanie));
    postForm('/koszyk/wysylka_lista', { id_kraj, id_platnosci })
      .then(data => {
        wysylkaContainers.forEach(el => (el.innerHTML = data));
      })
      .catch(() => {});
  }

  // przejście do wyboru wysyłki
  wyborWysylki();
  return false;
}

export function wyborWysylki() {
  const selectW = document.querySelector('select[name="hash_wysylka"]');
  // jeśli nie ma selecta – nadal podpinamy handler na document, ale jeśli chcemy
  // zachować oryginalne zachowanie, zwróć false gdy brak selecta
  if (!selectW) return false;

  const ladowanie = '<div class="progress-bar"></div>';

  if (_wysylkaHandler)
    document.body.removeEventListener('change', _wysylkaHandler);
  _wysylkaHandler = function (e) {
    if (e.target && e.target.matches('select[name="hash_wysylka"]')) {
      wyborWysylki();
      e.preventDefault();
    }
  };
  document.body.addEventListener('change', _wysylkaHandler);

  const inputKraj = document.querySelector('input[name="id_kraj"]');
  let id_kraj = inputKraj ? inputKraj.value : 0;
  if (id_kraj === undefined || id_kraj === null) id_kraj = 0;

  const selectPlat = document.querySelector('select[name="id_platnosci"]');
  let id_platnosci = selectPlat ? selectPlat.value : 0;
  if (id_platnosci === undefined || id_platnosci === null) id_platnosci = 0;

  let id_wysylka = selectW ? selectW.value : 0;
  if (id_wysylka === undefined || id_wysylka === null) id_wysylka = 0;

  const opisElems = Array.from(
    document.querySelectorAll('.wysylka-pojemnik div .opis-wysylki')
  );
  if (opisElems.length > 0) {
    opisElems.forEach(el => (el.innerHTML = ladowanie));
    postForm('/koszyk/wysylka_info', { id_kraj, id_platnosci, id_wysylka })
      .then(data => {
        // czyścimy input wysylka_info (tak jak w oryginale)
        const wysylkaInfoInputs = Array.from(
          document.querySelectorAll('input[name="wysylka_info"]')
        );
        wysylkaInfoInputs.forEach(i => (i.value = ''));

        opisElems.forEach(el => (el.innerHTML = data));
      })
      .catch(() => {});
  }

  return false;
}

export function czy_firma() {
  const select = document.querySelector('select#czy_firma');
  if (!select) return false;

  const val = select.value;

  // ukrywanie/pokazywanie elementów .konto-firma
  const kontoElems = Array.from(document.querySelectorAll('.konto-firma'));
  kontoElems.forEach(el => {
    if (val == '0' || val === 0) {
      el.style.display = 'none';
    } else {
      // przywracamy do domyślnego (pusty string pozwala CSS decydować)
      el.style.display = '';
    }
  });

  // zmiana - przypięcie listenera (usunięcie starego jeśli istanieje)
  if (_czyFirmaHandler) select.removeEventListener('change', _czyFirmaHandler);
  _czyFirmaHandler = function () {
    czy_firma();
  };
  select.addEventListener('change', _czyFirmaHandler);

  return false;
}
